
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingGrid extends Serenity.EntityGrid<SKURepricingRow, any> {
        protected getColumnsKey() { return 'Inventory.SKURepricing'; }
        protected getDialogType() { return SKURepricingDialog; }
        protected getIdProperty() { return SKURepricingRow.idProperty; }
        protected getInsertPermission() { return SKURepricingRow.insertPermission; }
        protected getLocalTextPrefix() { return SKURepricingRow.localTextPrefix; }
        protected getService() { return SKURepricingService.baseUrl; } 
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(100);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[100].AutoPosting;
            this.editItem(<SKURepricingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId:userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 100,
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions(); 
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}